import React from 'react'
import { Box } from 'theme-ui'
import ContentBoxes from '../components/ContentBoxes/v1/ContentBoxes'
export default function ContentBoxesV1(props) {
  const {
    options,
    // businessData,
    variantName
    // configData,
    // locationIndex,
  } = props

  const { containerStyles, containerID } = options

  const variant = variantName ? variantName : 'contentBoxesV1'
  const styles = containerStyles ? JSON.parse(containerStyles) : {}

  return (
    <Box variant={`${variant}.container`} className="container" id={containerID} sx={{ ...styles }}>
      <ContentBoxes {...props} variantName={variant} />
    </Box>
  )
}
